export const base64ToString = (text: string) => {
    try {
        return atob(text)
    } catch (error) {
        return ""
    }
}